<template>
  <a-modal
    :title="$t('base.settingUserName')"
    :width="450"
    :visible.sync="userVisible"
    @cancel="closeSettingUserNameModal"
    @ok="handleOkAddUser"
  >
    <div class="contentAddUserClass">
      <div class="top">
        <a-form-model :model="form" ref="formRef" layout="vertical" :rules="rules">
          <a-form-model-item prop="userName">
            <a-input v-model="form.userName" :placeholder="$t('base.limitLength', [2, 20])" style="width: 380px" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Modal } from '@/components'
import { getUserUpdate } from '@/api/user.js'
export default {
  name: 'addUserModal',
  props: {
    userId: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
  },
  components: {
    Modal,
  },
  data() {
    return {
      userVisible: true,
      form: {
        userName: '',
      },
    }
  },
  mounted() {},
  computed: {
    rules() {
      return {
        userName: [
          { required: true, message: this.$t('base.pleaseInputUserName'), trigger: 'change' },
          { min: 2, max: 20, message: this.$t('base.lengthIn', [2, 20]), trigger: 'blur' },
        ],
      }
    },
  },
  methods: {
    // 关闭
    closeSettingUserNameModal() {
      this.$emit('closeSettingUserNameModal')
    },
    // 确认
    handleOkAddUser() {
      this.$refs.formRef.validate((valid) => { 
        if (valid) {
          const data = {
            userName: this.form.userName,
            account: this.userId,
          }
          getUserUpdate(data)
            .then((res) => {
              this.$message.success(this.$t('tip.usernameChangeSuccess'))
              this.$emit('refreshDetail')
            })
            .catch((err) => {
              this.$message.error(err.message)
            })
        } else {
          // this.$message.warning(this.$t('base.limitLength', [2, 20]))
        }
      })
    },
  },
}
</script>

<style lang="less" scoped></style>
